import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=67248098&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports